import * as alerTypes from "../types/alert.types";

export const alertActions = {
  success,
  error,
  showError,
  clear,
  showMultipleMessage,
};

function success(message: string) {
  return { type: alerTypes.SUCCESS, message };
}

function showMultipleMessage(messages: string[]) {
  return { type: alerTypes.MULTIPLE, messages: messages };
}

function error(message: string) {
  return { type: alerTypes.ERROR, message };
}

function showError(error: any, externalMessage: string) {
  if (error?.response?.status === 0) {
    return { type: alerTypes.ERROR, message: "Network Error" };
  } else if (error?.response?.data?.message) {
    return {
      type: alerTypes.ERROR,
      message: error.response.data.message.toString(),
    };
  } else if (error?.response?.message) {
    return {
      type: alerTypes.ERROR,
      message: error.response.message.toString(),
    };
  } else if (error?.message) {
    return { type: alerTypes.ERROR, message: error.message.toString() };
  } else {
    return { type: alerTypes.ERROR, message: externalMessage };
  }
}

function clear() {
  return { type: alerTypes.CLEAR };
}
